import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';

import { selectCameraRecording, selectCountdownCamera, selectStartDelayTime } from '../../../store/modules/studio/selectors';
import { StudioControlStyles } from '../styles';
import { formatDuration } from '../../../utility/helpers';
import StudioToolTip from "../actions/StudioToolTip";

const Timer = () => {
  const classes = StudioControlStyles();

  const isRecording = useSelector(selectCameraRecording);
  const isCountdown = useSelector(selectCountdownCamera);
  const delayTime = useSelector(selectStartDelayTime);

  const [time, setTime] = useState(-delayTime);
  const intervalId = useRef<number | null>(null);
  const countdownIntervalId = useRef<number | null>(null);

  useEffect(() => {
    if (isCountdown && !countdownIntervalId.current) {
      setTime(-delayTime);
      const incrementTime = () => setTime((prev) => prev + 1);
      countdownIntervalId.current = window.setInterval(
        incrementTime,
        1000,
      );
    } else if (!isCountdown && countdownIntervalId.current) {
      window.clearInterval(countdownIntervalId.current);
      countdownIntervalId.current = null;
      setTime(-delayTime);
    }
    return () => {
      if (!isCountdown && countdownIntervalId.current) {
        window.clearInterval(countdownIntervalId.current);
      }
    };
  }, [isCountdown, delayTime, countdownIntervalId]);

  useEffect(() => {

    if (isRecording && !intervalId.current) {
      setTime(0);
      const incrementTime = () => setTime((prev) => prev + 1);
      intervalId.current = window.setInterval(
        incrementTime,
        1000,
      );
    } else if (!isRecording) {
      setTime(-delayTime);
      if(intervalId.current){
        window.clearInterval(intervalId.current);
        intervalId.current = null;
      }
    }
    return () => {
      if (!isRecording && intervalId.current) {
        window.clearInterval(intervalId.current);
      }
    };
  }, [isRecording, intervalId, delayTime]);

  return (
    <StudioToolTip title={'Recording countdown and timer'}>
      <Grid item className={classes.timer}>
        {formatDuration(time)}
      </Grid>
    </StudioToolTip>
  );
};

export default Timer;
